const { forEach, isFunction } = require('lodash');

class DigitalPayPrepaymentActionsService {
    constructor() {
        this._prePaymentActions = {};
    }

    init() {
        this._prePaymentActions = {};
    }

    /**
     * Add an invokable action associated with the given key.
     * Actions should all return promises to support delayed resolution of actions. |
     * When promise is resolved should return object with at least one of the the following formats: |
     * { paymentInstrumentId: 123, amount: 12 }, { paymentInstrumentId: 123, stepUpToken: abc } |
     * When promise is rejected should return object with at least the following format { id: actionKey, errorMessage: 'SomeError' }
     * @param {String} key
     * @param {Function} action
     */
    addAction(key, action) {
        if (!key || !action || !isFunction(action)) return;
        this._prePaymentActions[key] = action;
    }

    /**
     * Get action associated with the given key.
     * @param {String} key
     */
    getAction(key) {
        return this._prePaymentActions[key];
    }

    /**
     * Get all persisted actions.
     */
    getAllActions() {
        const actions = [];
        forEach(this._prePaymentActions, (action) => {
            actions.push(action);
        });
        return actions;
    }

    /**
     * Remove action associated with the given key.
     * @param {String} key
     */
    removeAction(key) {
        delete this._prePaymentActions[key];
    }

    /**
     * Remove all presisted actions.
     */
    removeAllActions() {
        this._prePaymentActions = {};
    }
}

module.exports = DigitalPayPrepaymentActionsService;



// WEBPACK FOOTER //
// ./src/digitalpay/services/digital-pay-prepayment-actions.service.js